import { Outlet } from "react-router-dom";
import AdminSidebar from "@/components/feature/AdminSidebar";
import AdminTopbar from "@/components/feature/AdminTopbar";
import AdminMobileNav from "@/components/feature/AdminMobileNav";
import { useAuth } from "@/context/AuthContext";
import { useBranches } from "@/hooks/useBranches";

export default function AdminLayout() {
  const { profile } = useAuth();
  const { branches } = useBranches();

  const branchName = branches.find((branch) => branch.id === profile?.branch_id)?.name ?? null;

  return (
    <div className="flex min-h-screen w-full bg-background-50">
      <AdminSidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <AdminTopbar branchName={branchName} />
        <main className="flex-1 px-4 pb-28 pt-6 md:px-6 lg:pb-10">
          <div className="mx-auto w-full max-w-[1400px]">
            <Outlet context={{ branchName }} />
          </div>
        </main>
      </div>

      <AdminMobileNav />
    </div>
  );
}